import * as cx from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import FeatureContainer from '../../../containers/feature'

import TrendingSash from '../../../components/trendingSash'
import ItemCardAudioContent from '../itemCardAudioContent'
import ItemCardCurrentAudioContent from '../itemCardCurrentAudioContent'
import ItemCardSmallSidebar from '../itemCardSmallSidebar'

import * as styles from './audioJungleItemCard.module.css'

interface IState {
  collapsed: boolean
}

class AudioJungleItemCard extends React.Component<IItemCard, IState> {
  public render() {
    const { item, viewType } = this.props

    const rootClass = cx(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <div className={rootClass}>
        <article className={styles.card}>
          {item.trending && <TrendingSash lazy />}
          <React.Fragment>
            <FeatureContainer name="!audioJungleItemCardFeatures">
              <ItemCardCurrentAudioContent {...this.props} />
            </FeatureContainer>
            <FeatureContainer name="audioJungleItemCardFeatures">
              <ItemCardAudioContent {...this.props} />
            </FeatureContainer>
          </React.Fragment>
          <div className={styles.sidebar}>
            <ItemCardSmallSidebar {...this.props} />
          </div>
        </article>
      </div>
    )
  }
}

export default AudioJungleItemCard
